import { createApp } from "vue";
import PrimeVue from "primevue/config";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./styles.css";
import "./styles-legacy-workspace.css";
import "./styles-clean.css";
import "./styles-clean-quality.css";
import "./styles-clean-statistics.css";
import "./styles-clean-settings.css";
import "./styles-clean-settings-layout.css";
import "./styles-clean-visitors.css";
import "./styles-clean-map.css";
import "./styles-clean-sidebar.css";
import "./styles-clean-detail.css";
import "./styles-clean-header.css";
import "./styles-visitor-detail.css";
import "./styles-shell-polish.css";
import { initializeLegacyLocalization } from "./i18n-dom";

createApp(App)
  .use(createPinia())
  .use(router)
  .use(PrimeVue, { unstyled: true, ripple: true })
  .mount("#app");

// Observe the complete body because dialogs and drawers are teleported next to
// #app. Limiting the observer to the application root left late-rendered
// overlays in the source language.
initializeLegacyLocalization(document.body);
